export default __webpack_public_path__ + "static/media/milad-mostavi.1e59dae6.png";